import { ReactElement } from "react";

export const NotFound = (): ReactElement => {

    return <div className="not-found">
        <h1>404</h1>
        <h2>Resource konnte nicht gefunden werden</h2>
    </div>
}